import {
  useEffect,
  useLayoutEffect,
  useState,
} from "react";

export function useWindowSize() {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount
  return {
    isMobile: windowSize.width < 768,
    isLarge: windowSize.width >= 1024,
    isDesktop: windowSize.width >= 768,
  };
}

export function useLockBodyScroll() {
  useLayoutEffect(() => {
    const scrollPosition = window.pageYOffset;
    // Get original body overflow
    const originalStyle = window.getComputedStyle(document.body).overflow;
    const originPosStyle = window.getComputedStyle(document.body).position;
    const originTopStyle = window.getComputedStyle(document.body).top;
    // Prevent scrolling on mount
    document.body.style.overflow = "hidden";
    //For IOS
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollPosition}px`;
    // Re-enable scrolling when component unmounts
    return () => {
      document.body.style.overflow = originalStyle;
      document.body.style.position = originPosStyle;
      document.body.style.top = originTopStyle;
      window.scrollTo(0, scrollPosition);
    };
  }, []); // Empty array ensures effect is only run on mount and unmount
}